import { Injectable, inject } from '@angular/core';

import { AclAccess, AclEntry, AclRequire, FsAcl } from '@firestitch/acl';
import { FsStore } from '@firestitch/store';

import { AclPermission } from '@app/common/enums';


@Injectable({
  providedIn: 'root',
})
export class AclService {
  private _store = inject(FsStore);
  private _acl = inject(FsAcl);


  constructor() {
    const _acl = this._acl;

    this._store.observe('permissions')
      .subscribe((event: any) => {
        const entries: AclEntry[] = [];
        if (event.value) {
          event.value.forEach((objectPermission) => {
            objectPermission.permissions.forEach((permission) => {
              entries.push({
                objectId: objectPermission.objectId,
                permissions: [
                  {
                    value: permission.value,
                    access: permission.access,
                  },
                ],
              });
            });
          });
        }

        _acl.setEntries(entries);
      });
  }

  public isAdmin(): boolean {
    return this.hasPermissionAdmin();
  }

  public hasPermissionAdmin(): boolean {
    return this._acl.has(AclPermission.Admin);
  }

  /**
   * Whether the account holds Organization on some organization: what the server asks before it
   * lists the organizations (GET environments), refusing anyone who holds it nowhere. On the
   * server Manage Staff and Admin include Organization (AclProvider), while the session lists only
   * the permissions a role names, so Manage Staff counts here too and an admin passes as always.
   */
  public hasPermissionOrganization(): boolean {
    return this.hasRead([AclPermission.Organization, AclPermission.Staff]);
  }

  /**
   * Whether the account may open the Staff page for an organization, the session's: the page
   * lists one organization's staff, so with none there is nothing to open, even for an admin;
   * with one it asks Manage Staff at write on it, which an admin holds on every organization.
   * The Staff menu item and StaffGuard both ask this, so the link shows exactly when the page opens.
   */
  public hasPermissionStaff(environmentId: number): boolean {
    return !!environmentId && this.hasWrite(AclPermission.Staff, environmentId);
  }

  public hasRead(permissions: string[] | string, object?: any, aclRequire?: AclRequire): boolean {
    return this.has(permissions, AclAccess.Read, object, aclRequire);
  }

  public hasWrite(permissions: string[] | string, object?: any, aclRequire?: AclRequire): boolean {
    return this.has(permissions, AclAccess.Write, object, aclRequire);
  }

  public hasFull(permissions: string[] | string, object?: any, aclRequire?: AclRequire): boolean {
    return this.has(permissions, AclAccess.Full, object, aclRequire);
  }

  public has(permissions: string[] | string, access?: AclAccess, objects?: any, aclRequire?: AclRequire): boolean {
    return this.isAdmin() || this._acl.has(permissions, access, objects, aclRequire);
  }

}
